<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781466804319_toc01#toctitle2" id="title2"><span><strong class="b">Acknowledgments</strong></span></a></div>
<div class="p"><span>I wish to thank my wife, Eleanor, for her many hours proofreading the manuscript. Without her painstaking work, the manuscript would never have gotten past the rough-notes stage. I would like also to cite my son, Bob, who typed much of the initial draft, and Mike Friedman, who provided new concepts and assistance.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466804319_ack01.vue?527e591f